import { render } from "./FactorsResult.vue?vue&type=template&id=5d36dd7f&scoped=true"
import script from "./FactorsResult.vue?vue&type=script&lang=js"
export * from "./FactorsResult.vue?vue&type=script&lang=js"

import "./FactorsResult.vue?vue&type=style&index=0&id=5d36dd7f&scoped=true&lang=css"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d36dd7f"]])

export default __exports__